import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p className="footer-text">
         &copy; {currentYear} Ladle Logic - A Product of Codeswift Technologies</p>
      </div>
    </footer>
  );
};

export default Footer;
